const unitConstantsEnum = Object.freeze({
    LB_PER_KG: 2.20462262185,
    TONNE_PER_KG: 0.001,
    ACRES_PER_HECTARE: 2.47105381467,
    M3_PER_BUSHEL: 0.0352390704,
    DEFAULT_DENSITY: 60.0,
})

export default unitConstantsEnum